module.exports = __webpack_public_path__ + "img/picture_teachvideo3@2x.79ba777d.png";